<template>
  <Widget height="auto" width="300px">
    <Calculator />
  </Widget>
</template>

<script>
import Widget from '../Widget.vue';
import Calculator from './Calculator.vue';

export default {
  components: { Calculator, Widget },
  computed: {
  },
  methods: {
  }
}
</script>